import { cn } from "@newxsystems/shared";
import { StratosAction } from "../StratosAction/StratosAction";
import { StratosMedia } from "../StratosMedia/StratosMedia";
import { StratosRichText } from "../StratosRichText/StratosRichText";
import type { ICallToActionStackedProps } from "./CallToActionStacked.props";

const widths = { small: "w-1/2", medium: "w-3/4", large: "w-full" } as const;

export const CallToActionStacked = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  imageWidth,
}: ICallToActionStackedProps) => {
  const centered = alignment === "center";
  return (
    <div className={cn("flex flex-col gap-5", centered && "items-center text-center")}>
      {eyebrow ? (
        <p className="border-b border-cloud-white/40 pb-2 font-stratos-body text-xs">{eyebrow}</p>
      ) : null}
      {image ? (
        <StratosMedia
          aspectRatio={image.aspectRatio || "16:9"}
          className={cn("my-3", widths[imageWidth || "medium"])}
          media={image.image}
          sizes="(min-width: 1024px) 70vw, 100vw"
        />
      ) : null}
      {heading ? (
        <h2
          className={cn(
            "font-stratos-display text-4xl font-bold leading-[0.98] tracking-[-0.025em] [overflow-wrap:anywhere] md:text-6xl",
            !centered && imageWidth === "large" ? "max-w-none" : "",
            !centered && imageWidth === "medium" ? "max-w-[30ch]" : "",
            !centered && imageWidth === "small" ? "max-w-[16ch]" : "",
            centered && "max-w-[16ch]",
          )}
        >
          {heading}
        </h2>
      ) : null}
      {description ? (
        <StratosRichText className="max-w-[65ch] text-cloud-white" content={description} />
      ) : null}
      {buttons?.length ? (
        <div className={cn("flex flex-wrap gap-3 pt-3", centered && "justify-center")}>
          {buttons.map((button, index) => (
            <StratosAction
              action={button}
              className="border-cloud-white text-cloud-white"
              key={`${button.href}-${index}`}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

CallToActionStacked.displayName = "Content::CallToActionStacked";
